<template>
<!-- 手机行业解决方案 -->
    <section class="solution others-solution">
        <div class="layout-banner">
            <div class="banner_box"></div>
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">其他行业解决方案</div>
                    <div class="sm-text">OTHER INDUSTRY SOLUTIONS</div>
                    <!-- <div class="line"></div> -->
                </div>
            </div>
            <Nav :activeIndex='"2-4"'></Nav>
        </div>
        <div class="solution-content">
            <p class="applications-title">其他行业解决方案</p>
            <p class="subhead">OTHER INDUSTRY SOLUTIONS</p>
            <div class="solution-context">
                <div class="w-1200">
                    <div class="title">常见问题</div>
                    <div class="desc">
                        <ul>
                            <li>保费低查勘贵</li>
                            <li>理赔资料造假</li>
                            <li>黄牛团队骗保</li>
                            <li>风控手段缺乏</li>
                            <li>报案流程繁琐</li>
                            <li>人工核赔时效长</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="solution-scene">
                <div class="w-1200">
                    <div class="title">覆盖场景</div>
                    <div class="desc">
                        <div class="scene-row">
                            <div class="item">
                                <div class="imgbox"></div>
                                <img src='../../assets/solution/jcx.png' alt="">
                                <div class="bottom-title">服务型家财险</div>
                            </div>
                            <div class="item">
                                <div class="imgbox"></div>
                                <img src='../../assets/solution/ywx.png' alt="">
                                <div class="bottom-title">骑手意外险/雇主险</div>
                            </div>
                            <div class="item">
                                <div class="imgbox"></div>
                                <img src='../../assets/solution/fl.png' alt="">
                                <div class="bottom-title">法律服务保险</div>
                            </div>
                            <div class="item">
                                <div class="imgbox"></div>
                                <img src='../../assets/solution/qc.png' alt="">
                                <div class="bottom-title">汽车轮胎险</div>
                            </div>
                        </div>
                    </div>
                </div>
                <img :src="require(`../../assets/solution/icon${item}.png`)" alt="" v-for="item in 8" :key="item" :class="`icon${item}`">
            </div>
            <div class="solution-feature">
                <div class="w-1200">
                    <div class="title">能力模组</div>
                    <div class="desc">
                        <div class="left-top">30+风控接口集成</div>
                        <div class="left-center">移动端平台敏捷开发能力</div>
                        <div class="left-bottom">保险智能中台支撑各类产品</div>
                        <div class="right-top">智能理赔系统高效核赔</div>
                        <div class="right-center">合作伙伴API深度交互</div>
                        <div class="right-bottom">理赔资料AI防伪解析</div>
                    </div>
                </div>
            </div>
            <div class="solution-customer">
                <div class="w-1200">
                    <div class="title">合作客户</div>
                    <div class="desc">
                        <div class="customer"><img src="../../assets/partners/phone/partners2.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners14.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners5.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners11.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners12.jpg" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      tabsBarleft: 0,
      activeScene: 0,
      allSceneList: []
    }
  },
  methods: {
    sceneClick (index) {
      this.activeScene = index
      this.tabsBarleft = index * 122
    }
  }
}

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.others-solution{
    .banner_box{
        background-image: url(../../assets/banner6.png);
    }
    .solution-content{
        .solution-context{
            margin: 40px 0 60px 0;
            .desc{
                width: 100%;
                padding:40px 30px;
                box-shadow:0px 2px 18px rgba(3, 123, 255, 0.1);
                margin-top: 30px;
                font-size: 14px;
                color: #666;
                line-height: 2;
                cursor: pointer;
                transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                &:hover{
                    transform: translateY(-3px);
                    box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.15);
                    transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    li{
                        width: 100%;
                        text-align: center;
                        border-right: 1px solid #E9EFF9;
                        padding:5px ;
                        &:last-child{
                            border-right: none;
                        }
                    }
                }
                // width: 100%;
                // margin-top: 30px;
                // font-size: 14px;
                // color: #666;
                // line-height: 2;
                // ul{
                //     display: flex;
                //     justify-content: space-between;
                //     li{
                //         text-align: center;
                //         padding: 30px 40px;
                //         box-shadow:0px 2px 18px rgba(3, 123, 255, 0.1);
                //         transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                //         img{
                //             height: 60px;
                //         }
                //         &:hover{
                //             transform: translateY(-3px);
                //             box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.1);
                //             transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                //         }
                //     }
                // }
            }
        }
        .solution-scene{
            .desc{
                .scene-row{
                    width: 100%;
                    .item{
                        // cursor: pointer;
                        position: relative;
                        img{
                            // width: 60px;
                            height: 50px;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%,-75%);
                            // top: 50px;
                        }
                        .imgbox{
                            width: 164px;
                            height: 164px;
                            margin: 0 auto;
                            position: relative;
                            background: url(../../assets/solution/scenebg.png) no-repeat;
                            background-size: 164px 154px;
                            background-position-y: 5px;
                            line-height: 208px;
                            transform-style: preserve-3d;
                            transition: transform 1s;
                            &:hover{
                                transform: rotate(180deg);
                            }
                        }
                        .bottom-title{
                            font-size: 18px;
                        }
                    }
                }
            }
        }
        .solution-feature{
            background-color:#f5faff;
            padding-top: 40px;
            .desc{
                background-image: url(../../assets/solution/solution4.png);
                background-repeat: no-repeat;
                background-position: 50% 50%;
                height: 550px;
                width: 100%;
                position: relative;
                font-size: 14px;
                color: #666666;
                &>div{
                    position: absolute;
                    height: 52px;
                    width: 200px;
                    display: flex;
                    align-items: center
                }
                .left-top{
                    left: 240px;
                    top: 92px;
                }
                .left-center{
                    left: 165px;
                    top: 250px;
                }
                .left-bottom{
                    left: 208px;
                    top: 407px;
                }
                .right-top{
                    right: 105px;
                    top: 92px;
                }
                .right-center{
                    right: 75px;
                    top: 250px;
                }
                .right-bottom{
                    right: 105px;
                    top: 407px;
                }
            }
        }
    }
}
</style>
